import { myDesignedSwag, shopOurCatalog } from "@constants/widgets";
import { ALL_PRODUCTS } from "@constants/routes";

export const MENU_INTENT = "eshop";
export const SWAGMAGIC_INTENT = "swagmagic";
export const ESHOP_FAV_LOCATION_TYPE = "eshop-fav";
export const ESHOP_PROMO_LOCATION_TYPE = "eshop-promo";
export const ESHOP_FEATURED_LOCATION_TYPE = "eshop-featured";
export const ESHOP_FEATURED_SHOP_LOCATION_TYPE = "eshop-store-listing";
export const ESHOP_FAV_CAROUSEL = "eshop-fav-carousel";
export const WIDGETS_MENU_MAPPING = {
  [shopOurCatalog]: {
    type: ESHOP_FEATURED_LOCATION_TYPE,
    count: 45,
  },
  [myDesignedSwag]: {
    count: 5,
  },
};

export const MY_DESIGNED_SWAG_LOCKER = "locker-my-designed-swag";
export const LOCKER_MENU_ITEMS = [MY_DESIGNED_SWAG_LOCKER, ALL_PRODUCTS];
export const PREDEFINED_MENU_ITEMS = [MY_DESIGNED_SWAG_LOCKER, ALL_PRODUCTS];

export const WIDGETS_MENU_VISIBLE_ON_RLP = [ESHOP_FAV_LOCATION_TYPE];

export const LARGE_PRODUCT_COUNT_NUMBER = 1000;
export const LARGE_SHOP_PRODUCT_COUNT_NUMBER = 5000;

export const CLOUDINARY_ATTACHMENT_HEIGHT = "cloudinary_h";
export const CLOUDINARY_ATTACHMENT_WIDTH = "cloudinary_w";

export const MENU_ITEM_IMAGE_HEIGHT = 40;

export const PRICING_TYPE_CMS = "Spree::Cms::Pages::PricingPage";

export const CATEGORY_SEPARATOR = "--";

export const DEFAULT_MENU_ITEM_CODE = "default";

export const CAROUSEL_DISPLAY_TYPE = "Carousel";
export const VERTICAL_DISPLAY_TYPE = "Vertical";
export const HORIZONTAL_DISPLAY_TYPE = "Horizontal";
